import { MailIcon } from '@orn/shared-web/icons';

const SUPPORT_EMAIL = 'help@gomantle.com';

/**
 * Footer shown at the bottom of every {@link OnboardingLayout} screen.
 * Renders the support-email contact aligned to the start of the form column.
 */
const OnboardingFooter = () => {
  return (
    <div className="text-tertiary flex w-full items-center justify-start text-sm">
      <a className="flex items-center gap-2" href={`mailto:${SUPPORT_EMAIL}`}>
        <MailIcon className="size-4 shrink-0" />
        <span>{SUPPORT_EMAIL}</span>
      </a>
    </div>
  );
};

OnboardingFooter.displayName = 'OnboardingFooter';

export default OnboardingFooter;
